import { AXIOS } from '../http-common';

const base = '/area-cliente-api';
const authBase = '/api';

export default {
    // Autenticação
    login: async function (credentials) {
        return await AXIOS.post(authBase + '/auth/cliente/login', credentials);
    },
    
    // Dados básicos
    obterListaComboComprasDaFicha: async function (fichaId) {
        return await AXIOS.get(base + '/obterListaComboComprasDaFicha/' + fichaId);
    },
    obterListaComboTaxasDaFicha: async function (fichaId) {
        return await AXIOS.get(base + '/obterListaComboTaxasDaFicha/' + fichaId);
    },
    
    // Boletos (sistema usa apenas boletos avulsos, não carnês)
    listarBoletosPorCompra: async function (dados) {
        return await AXIOS.post(base + '/listarBoletosPorCompra', dados);
    },
    listarBoletosPorTaxa: async function (dados) {
        return await AXIOS.post(base + '/listarBoletosPorTaxa', dados);
    },
    listarParcelasEntrada: async function (dados) {
        return await AXIOS.post(base + '/listarParcelasEntrada', dados);
    },
    
    // Dashboard e resumos
    obterDashboard: async function (fichaId) {
        return await AXIOS.get(base + '/obterDashboard/' + fichaId);
    },
    obterResumoFinanciamento: async function (fichaId) {
        return await AXIOS.get(base + '/obterResumoFinanciamento/' + fichaId);
    },
    obterDadosDaProposta: async function (fichaId) {
        return await AXIOS.get(base + '/obterDadosDaProposta/' + fichaId);
    },
    
    // Novos endpoints com correção monetária
    obterSaldoDevedorAtualizado: async function (fichaId) {
        return await AXIOS.get(base + '/obterSaldoDevedorAtualizado/' + fichaId);
    },
    obterHistoricoSaldoDevedor: async function (fichaId, meses) {
        if (!meses) meses = 12;
        return await AXIOS.get(base + '/obterHistoricoSaldoDevedor/' + fichaId + '?meses=' + meses);
    },
    obterProjecaoQuitacao: async function (fichaId) {
        return await AXIOS.get(base + '/obterProjecaoQuitacao/' + fichaId);
    }
}


// WEBPACK FOOTER //
// ./src/api/app.api.js